/**
 * GrowthBook experiment feature keys. An experiment's variants, weights and hash attribute live
 * in GrowthBook; the app only evaluates the key (`useExperiment`), and the growthbook exposure
 * sink reports the exposure. Distinct from the assessment registry in
 * `features/assessments/experiments/`, which is frozen until its teardown.
 */
export const EXPERIMENTS = {
  /** End-to-end pipeline smoke test; its rule exists only in GrowthBook's dev environment. */
  SMOKE_E2E: "ageless-smoke-e2e",
} as const;

export type ExperimentKey = (typeof EXPERIMENTS)[keyof typeof EXPERIMENTS];
